<template>
  <div>
    <el-dialog width="50%" :visible.sync="checkedMealTimeBoxState">
      <div class="restaurantAddCheckDateBox">
        <p class="cleanFloat">
          <b>{{resourceObj.nameCn}}</b>
          <button @click="restaurantAddYs">保存</button>
        </p>
        <div><b>{{productObj.productName}}</b></div>
        <div style="margin-bottom:10px;margin-top: 10px">
          <b>添加行程轴内所需的{{resourceObj.state==1?'会议':'公务'}}时间</b>
          <i class="el-icon-plus" @click="addOfficialInvitationTime"></i>
          <!-- <b v-if="$parent.resourceType=='officialInvitation'" style="margin-left: 530px;">使用城市</b> -->
        </div>
        <ul>
          <li v-for="(data, index) in officialInvitationDateArr" :key="index" style="padding-left:0px">
            <el-select v-model="data.date" placeholder="请选择" size="mini" style="width: 1.3rem" value-key="plandate">
              <el-option v-for="(item, ind) in chenckBudgteObj.planDayList" :key="ind" :label="dateFormatYMD(item.planDate,'-')" :value="dateFormatYMD(item.planDate,'-')"></el-option>
            </el-select>
            <site-time :data="data" :index="index" @deleteOfficialInvitationTime="deleteOfficialInvitationTime($event,officialInvitationDateArr)"></site-time>
          </li>  
        </ul>  
        <div style="margin-top:0.3rem">
          <b>添加行程轴外所需的{{$parent.resourceType=='officialInvitation'?'公务':'会议'}}时间</b>
          <i class="el-icon-plus" @click="addOfficialInvitationTime('other')"></i>
        </div> 
        <ul>
          <li v-for="(data, index) in officialInvitationOtherDateArr" :key="index" style="padding-left:0px">
            <el-date-picker v-model="data.date" value-format="timestamp" align="right" type="date" size="mini" placeholder="选择日期" 
              style="width: 1.3rem;    height: 0.28rem;"></el-date-picker>
            <site-time :data="data" :index="index" @deleteOfficialInvitationTime="deleteOfficialInvitationTime($event,officialInvitationOtherDateArr)"></site-time>
          </li>  
        </ul>  
      </div>
    </el-dialog>
  </div>
</template>

<script>
import siteTime from './siteTime.vue'
import PlanApi from '@/components/Api/PlanApi.js'
import { refresh } from '../../../js/function'
export default {
  components: { siteTime },
  data(){
    return{
      checkedMealTimeBoxState:false,
      resourceObj:{},
      productObj:{},
      officialInvitationDateObj:{
        date:null,
        time:null,
        onehour:null,
        onemin:null,
        twohour:null,
        twomin:null,
      },
      officialInvitationDateArr:null,
      officialInvitationOtherDateArr:null,
      planDays:[]
    }
  },
  props:{
    chenckBudgteObj:{
      type:Object,
      default:()=>{return {}}
    },
    keyStr:{
      type:String,
      default:''
    }
  },
  methods:{
    getDateObj(arr){
      var dateList=[]
      arr.forEach(time=>{
        dateList.push({
          cityId:this.resourceObj.cityId,
          cityName:this.resourceObj.cityName,
          cityNameEn:this.resourceObj.cityNameEn,
          planDate:time.date,
          timeType:time.time=='other'?'':time.time,
          onehour:time.onehour,
          onemin:time.onemin,
          twohour:time.twohour,
          twomin:time.twomin,
        })
      })
      return dateList
    },
    restaurantAddYs(){
      this.productObj.priceList = [{ priceCompany:'间' }]
      var arr = [{
        stockId:0,
        stockNumber:this.productObj.stockNumber,
        productId:0,
        productName:this.productObj.productName,
        stockPrice:this.productObj.price,
        ratio:this.productObj.salePrice,
        currency:this.productObj.currency,
        priceResult:this.productObj
      }]
      var list = this.getDateObj(this.officialInvitationDateArr)
      var list1 = this.getDateObj(this.officialInvitationOtherDateArr)
      var dateList=[...list,...list1]
      var obj = {
        budgetMainId:this.$store.state.budgetMainId,
        planId:this.$store.state.planId,
        state:this.resourceObj.state,
        productType:10,
        resourceId:this.resourceObj.id,
        resourceNameCn:this.resourceObj.nameCn,
        resourceNameEn:this.resourceObj.nameEn,
        planDayList:dateList,
        key:this.keyStr,
        details:arr
      }
      new PlanApi('plan').budgetAdd(obj).then(res => {
        if (res.status == 200) {
          this.$message({type:"success",message:"添加成功"})
          this.checkedMealTimeBoxState = false
          this.$emit("closeDialog");
          refresh(res.data,this.$store.state.planId,this.$store.state.budgetMainId,'refresh')
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    },
    beforeOpen(item,item1){
      this.checkedMealTimeBoxState = true
      this.resourceObj = item
      this.productObj = item1
      this.officialInvitationDateArr=[JSON.parse(JSON.stringify(this.officialInvitationDateObj))]
      this.officialInvitationOtherDateArr=[]
    },
    addOfficialInvitationTime(type){
      var obj = JSON.parse(JSON.stringify(this.officialInvitationDateObj))
      alert(type)
      if(type&&type=='other'){
        this.officialInvitationOtherDateArr.push(obj)
      }else{
        this.officialInvitationDateArr.push(obj)
      }
    },
    deleteOfficialInvitationTime(index,arr){
      arr.splice(index,1)
    }
  }
}
</script>

<style lang="scss" scoped>
.restaurantAddCheckDateBox {
  padding: 0.3rem 0.3rem 0.3rem 0.2rem;
  color: black;
  > p {
    margin: 0.05rem 0;
    b {
      font-size: 0.16rem;
      color: #db4e1a;
    }
    button {
      float: right;
      color: #fff;
      background: #db4e1a;
      padding: 0.05rem 0.15rem;
      vertical-align: middle;
      margin-right: 0.2rem;
      border: none;
    }
  }
  ul {
    li {
      margin: 5px 0;
      min-height: 28px;
      padding: 0 10px;
      display: flex;
    }
  }
}
</style>